import React, { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import api from '../../services/api';
import AiReviewButtons from './AiReviewButtons';
export default function AiReconciliationPanel({ rowId }) {
  const [data, setData] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const analyze = async () => {
    setBusy(true); setError(''); setData(null);
    try { setData((await api.post(`/ai/reconciliation/${rowId}`)).data); }
    catch (err) { setError(err.response?.data?.error || 'Suggerimento IA non disponibile.'); }
    finally { setBusy(false); }
  };
  return <Box sx={{ my: 2 }}>
    <Button disabled={!rowId || busy} onClick={analyze}>{busy ? 'Confronto…' : 'Confronta gli abbinamenti con Luna'}</Button>
    {error && <Alert severity="warning">{error}</Alert>}
    {data && <Alert severity="info"><Typography>{data.explanation}</Typography>
      {data.proposed && <Typography variant="body2">Candidato da verificare: {data.proposed.customer} · fattura {data.proposed.invoiceNumber || 'non individuata'} · importo proposto dal gestionale € {data.proposed.amount}</Typography>}
      {[...(data.uncertainties || []), ...(data.proposed?.warnings || [])].map((item, index) => <Typography key={index} variant="body2">{item}</Typography>)}
      <Typography variant="caption">La proposta non registra alcun pagamento. Usa i controlli di assegnazione e conferma dopo aver verificato cliente e fatture.</Typography>
      <AiReviewButtons key={data.requestId} requestId={data.requestId} />
    </Alert>}
  </Box>;
}
